import { render, staticRenderFns } from "./FamilyIdentity.vue?vue&type=template&id=20318c32&scoped=true&"
import script from "./FamilyIdentity.vue?vue&type=script&lang=js&"
export * from "./FamilyIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20318c32",
  null
  
)

export default component.exports